<form
  [formGroup]="(form.get(formSectionName) ? form.get(formSectionName) : form) | as : FormGroup"
  *transloco="let t; read: TRANSLATION_SCOPE"
>
  <div class="row pb-2 mx-2" [ngClass]="borderBottom ? 'border-bottom ' : ''">
    <rx-select
      placeholder="Title"
      formControlName="title"
      rxMandatory
      class="pl-md-0 col-md-2"
      [compact]="compact"
      [options]="titleOptions$ | async"
      [label]="t('title.label')"
      [attr.data-qa]="'test-guest-title'"
    >
      <div rx-error *ngIf="hasError('title') as error">{{ t(error?.text, { params: error?.params }) }}</div></rx-select
    >
    <rx-input
      type="text"
      formControlName="firstName"
      rxMandatory
      [ngClass]="compact ? 'col-md-3' : 'col-md-5'"
      [compact]="compact"
      [label]="t('firstName.label')"
      [attr.data-qa]="'test-guest-firstName'"
    >
      <div rx-error *ngIf="hasError('firstName') as error">{{ t(error?.text, { params: error?.params }) }}</div></rx-input
    >
    <rx-input
      type="text"
      formControlName="lastName"
      [ngClass]="compact ? 'col-md-3' : 'col-md-5 pr-0'"
      [compact]="compact"
      [label]="t('lastName.label')"
      [attr.data-qa]="'test-guest-lastname'"
      rxMandatory
    >
      <div rx-error *ngIf="hasError('lastName') as error">{{ t(error?.text, { params: error?.params }) }}</div></rx-input
    >
    <rx-input
      type="text"
      formControlName="email"
      rxMandatory
      [ngClass]="compact ? 'col-md-4' : 'col-md-6 px-0'"
      [compact]="compact"
      [label]="t('email.label')"
      [attr.data-qa]="'test-guest-email'"
    >
      <div rx-error *ngIf="hasError('email') as error">{{ t(error?.text, { params: error?.params }) }}</div></rx-input
    >
  </div>
</form>
